import React, { useEffect, useState } from "react";
import { FileText, Table2, Download } from "lucide-react";
import api, { API } from "../lib/api";
import { toast } from "sonner";

export default function ReportsPage() {
  const [areas, setAreas] = useState([]);
  const [areaId, setAreaId] = useState("");
  const [status, setStatus] = useState("");
  const [priority, setPriority] = useState("");
  const [fromDate, setFrom] = useState("");
  const [toDate, setTo] = useState("");

  useEffect(() => { api.get("/areas").then(({data}) => setAreas(data)); }, []);

  const dl = async (path, filename) => {
    try {
      const params = new URLSearchParams();
      if (areaId) params.append("area_id", areaId);
      if (status) params.append("status", status);
      if (priority) params.append("priority", priority);
      if (fromDate) params.append("from_date", fromDate);
      if (toDate) params.append("to_date", toDate);
      const token = localStorage.getItem("crejpp_token");
      const res = await fetch(`${API}${path}?${params.toString()}`, { headers: { Authorization: `Bearer ${token}` }, credentials: "include" });
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url; link.download = filename; link.click();
      URL.revokeObjectURL(url);
      toast.success("Reporte generado");
    } catch { toast.error("No se pudo generar el reporte"); }
  };

  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">Reportes</div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">Exportar reportes</h1>
        <p className="text-sm text-slate-500 mt-1">Genere reportes de tareas y proyectos en formato PDF o Excel.</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-6 space-y-4">
        <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">Filtros para el reporte de tareas</div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <label className="block"><span className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5">Estado</span>
            <select className="w-full input" value={status} onChange={e => setStatus(e.target.value)} data-testid="report-filter-status">
              <option value="">Todos los estados</option>
              <option value="pendiente">Pendiente</option>
              <option value="en_revision">En revisión</option>
              <option value="en_proceso">En proceso</option>
              <option value="cumplido">Cumplido</option>
              <option value="detenido">Detenido</option>
              <option value="vencidas">Vencidas</option>
            </select>
          </label>
          <label className="block"><span className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5">Prioridad</span>
            <select className="w-full input" value={priority} onChange={e => setPriority(e.target.value)} data-testid="report-filter-priority">
              <option value="">Todas las prioridades</option>
              <option value="baja">Baja</option>
              <option value="media">Media</option>
              <option value="alta">Alta</option>
              <option value="urgente">Urgente</option>
            </select>
          </label>
          <label className="block"><span className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5">Área</span>
            <select className="w-full input" value={areaId} onChange={e => setAreaId(e.target.value)} data-testid="report-filter-area">
              <option value="">Todas las áreas</option>
              {areas.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>
          </label>
          <label className="block"><span className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5">Desde</span>
            <input type="date" className="w-full input" value={fromDate} onChange={e => setFrom(e.target.value)} data-testid="report-filter-from" />
          </label>
          <label className="block"><span className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5">Hasta</span>
            <input type="date" className="w-full input" value={toDate} onChange={e => setTo(e.target.value)} data-testid="report-filter-to" />
          </label>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ReportCard icon={FileText} title="Reporte de Tareas" desc="Listado detallado de tareas con estado, responsable, prioridad y fechas.">
          <button onClick={() => dl("/reports/tasks/pdf", "reporte_tareas.pdf")} className="btn-primary" data-testid="report-tasks-pdf"><Download className="w-4 h-4" /> PDF</button>
          <button onClick={() => dl("/reports/tasks/excel", "reporte_tareas.xlsx")} className="btn-secondary" data-testid="report-tasks-excel"><Download className="w-4 h-4" /> Excel</button>
        </ReportCard>
        <ReportCard icon={Table2} title="Reporte de Proyectos" desc="Portafolio institucional con avance por proyecto y actividades.">
          <button onClick={() => dl("/reports/projects/pdf", "reporte_proyectos.pdf")} className="btn-primary"><Download className="w-4 h-4" /> PDF</button>
          <button onClick={() => dl("/reports/projects/excel", "reporte_proyectos.xlsx")} className="btn-secondary"><Download className="w-4 h-4" /> Excel</button>
        </ReportCard>
      </div>
      <style>{`
        .input { width:100%; padding:0.5rem 0.75rem; border:1px solid #cbd5e1; border-radius:0.375rem; font-size:0.875rem; background:white; }
        .input:focus { outline:none; border-color:#EE1C25; box-shadow:0 0 0 3px rgba(238,28,37,0.12); }
        .btn-primary { background:#EE1C25; color:white; padding:0.5rem 0.9rem; border-radius:0.375rem; font-size:0.875rem; font-weight:600; display:inline-flex; align-items:center; gap:0.4rem; }
        .btn-primary:hover { background:#B91419; }
        .btn-secondary { background:white; color:#334155; padding:0.5rem 0.9rem; border-radius:0.375rem; font-size:0.875rem; font-weight:500; border:1px solid #cbd5e1; display:inline-flex; align-items:center; gap:0.4rem; }
        .btn-secondary:hover { background:#f8fafc; }
      `}</style>
    </div>
  );
}

function ReportCard({ icon: Icon, title, desc, children }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-6">
      <div className="w-10 h-10 rounded-md bg-red-50 text-crejpp flex items-center justify-center mb-3"><Icon className="w-5 h-5" /></div>
      <h3 className="font-heading font-semibold text-lg text-slate-900">{title}</h3>
      <p className="text-sm text-slate-500 mt-1 mb-4">{desc}</p>
      <div className="flex gap-2">{children}</div>
    </div>
  );
}
